import clusterApi from './endpoints/cluster';
import datasetApi from './endpoints/dataset';
import datasetAccessApi from './endpoints/datasetAccess';
import emrApi from './endpoints/emr';
import etlApi from './endpoints/etlJobs';
import memberApi from './endpoints/member';
import noticeBannerApi from './endpoints/noticeBanner';
import operatingUnitApi from './endpoints/operatingUnit';
import projectApi from './endpoints/project';
import serviceNowApi from './endpoints/serviceNow';
import storageApi from './endpoints/storage';
import userApi from './endpoints/user';
import wbsCodeApi from './endpoints/wbsCode';
import workbenchApi from './endpoints/workbench';
import workspaceApi from './endpoints/workspaces';

export const {
  useGetDatasetsInfiniteQuery,
  useGetDatasetQuery,
  useCreateDatasetMutation,
  useEditDatasetMutation,
  useGetDatasetPresignedUrlMutation,
  useGetDatasetFilesQuery,
  useUploadDatasetFilesMutation,
  useGetDatasetEnumsQuery,
  useGetDatasetInstructionsQuery,
  useLazyGetDatasetInstructionsQuery,
  useLazyGetDatasetConnectionRolesQuery,
  useDeleteDatasetFileMutation,
  useRenameDatasetFileMutation,
  useDownloadDatasetFileMutation,
  useGetValidateDatasetNameQuery,
  useLazyGetValidateDatasetNameQuery,
  useGetValidateMdtIdQuery,
  useSendDatasetToAtlanMutation,
} = datasetApi;
export const { useCreateEmrMutation, useDeleteEmrMutation, useGetEmrsQuery, useEditEmrMutation } = emrApi;
export const { useCreateClusterMutation, useDeleteClusterMutation, useGetClustersQuery } = clusterApi;
export const {
  useGetProjectsInfiniteQuery,
  useGetProjectQuery,
  useCreateProjectMutation,
  useEditProjectMutation,
  useDeactivateProjectMutation,
  useGetDatasetsForSelectionQuery,
  useGetValidateProjectNameQuery,
  useLazyGetValidateProjectNameQuery,
} = projectApi;
export const { useClearCrossRegionAccessMutation, useGetUserQuery, useGetUsersQuery, useGetUserDatasetsQuery } =
  userApi;
export const {
  useGetProjectWorkbenchesQuery,
  useLazyGetConnectToWorkbenchQuery,
  useCreateWorkbenchMutation,
  useStartWorkbenchMutation,
  useStopWorkbenchMutation,
  useTerminateWorkbenchMutation,
  useGetWorkbenchTypesQuery,
  useAutoStopWorkbenchMutation,
  useDeleteAutoStopWorkbenchMutation,
} = workbenchApi;
export const { useGetOperatingUnitsQuery } = operatingUnitApi;
export const {
  useGetNewMembersQuery,
  useAddMemberMutation,
  useRemoveMemberMutation,
  useTransferOwnershipMutation,
  useChangeMemberRoleMutation,
} = memberApi;
export const { useRequestDatasetMutation } = serviceNowApi;
export const {
  useGetStorageQuery,
  useCreateFolderMutation,
  useUploadStorageFilesMutation,
  useUploadLargeFileMutation,
  useRenameFolderMutation,
  useDeleteFolderMutation,
  useGetStorageStatsQuery,
  useDeleteFilesMutation,
  useRenameFileMutation,
  useDownloadFileMutation,
  useGetPresignedUploadUrlMutation,
  useCompleteS3UploadMutation,
} = storageApi;
export const {
  useGetScheduledETLJobsQuery,
  useGetETLJobsHistoryQuery,
  useDeleteETLJobMutation,
  useCreateScheduledJobMutation,
  useGetScheduledETLJobQuery,
  useEditScheduledJobMutation,
  useGetETLJobLogInfiniteQuery,
} = etlApi;
export const { useGetWorkspacesQuery, useGetWorkspaceFilesQuery } = workspaceApi;
export const {
  useGetDatasetAccessQuery,
  useGetDatasetAffectedProjectsQuery,
  useLazyGetDatasetAffectedProjectsQuery,
  useRevokeDatasetAccessMutation,
} = datasetAccessApi;
export const { useGetWbsCodesQuery, useGetWbsCodeQuery, useGetСostCenterQuery } = wbsCodeApi;
export const {
  useGetNoticeBannersQuery,
  useCreateNoticeBannerMutation,
  useDeleteNoticeBannerMutation,
  useEditNoticeBannerMutation,
} = noticeBannerApi;
